import { COUNTRY_CODE } from '../config'


import {
    isPossiblePhoneNumber,
    isValidPhoneNumber,
    validatePhoneNumberLength,
    parsePhoneNumber
} from 'libphonenumber-js'

const PhoneUtils = {}

PhoneUtils.formatPhoneNumberVN = (phone) => {
    if (phone.startsWith('+84')) {
        return `0${phone.substring(3)}`
    } if (phone.startsWith('84')) {
        return `0${phone.substring(2)}`
    }
    return phone;
}

PhoneUtils.formatPhoneNumberLao = (phone) => {
    if (phone.startsWith('856')) {
        return `+${phone}`
    } else if (phone.startsWith('0')) {
        return `+856${phone.substring(1)}`
    } else if (phone.startsWith('+856')) {
        return phone;
    }
    return `+856${phone}`
}

PhoneUtils.formatPhoneNumber = (phone) => {
    switch (COUNTRY_CODE) {
        case 'LA':
            return PhoneUtils.formatPhoneNumberLao(phone)
        case 'VN':
        default:
            return PhoneUtils.formatPhoneNumberVN(phone)
    }
}

PhoneUtils.formatPhoneNumberToShowLao = (phone) => {
    if (phone.startsWith('+856')) {
        return `0${phone.substring(4)}`
    }
    return phone
}

PhoneUtils.formatPhoneNumberToShow = (phone) => {
    switch (COUNTRY_CODE) {
        case 'LA':
            return PhoneUtils.formatPhoneNumberToShowLao(phone)
        case 'VN':
        default:
            return phone
    }
}

PhoneUtils.isValidPhoneNumberByCountry = (value) => {
    const phone = PhoneUtils.formatPhoneNumber(value)

    return isValidPhoneNumber(phone, COUNTRY_CODE)
}

export default PhoneUtils
